import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { localize } from 'core/localization';
import { BUTTON, INPUT_TYPE } from 'constants/components';
import { getEmail, getName } from 'store/user/selectors';
import { USER_ALREADY_EXISTS } from 'constants/progressStorage';
import progressStorage from 'core/progressStorage';
import Input from '../Input';
import { Form, ButtonSubmit, InputContainer } from './SignUpForm.styled';

export class SignUp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: '',
      email: '',
      password: '',
      validationStatusBeforeSubmit: {
        name: true,
        email: true,
        password: true
      },
      isUserExist: false
    };
    this.refName = '';
    this.refEmail = '';
    this.refPass = '';
  }

  componentDidMount() {
    let { userEmail, userName } = this.props;

    if (userEmail || userName) {
      this.setState({
        email: userEmail || '',
        name: userName || ''
      });
    }
  }

  onChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  beforeSubmitValidation = (event, onSubmit) => {
    event.preventDefault();
    const nameValid = this.refName ? this.refName.validity.valid : false;
    const emailValid = this.refEmail ? this.refEmail.validity.valid : false;
    const passwordValid = this.refPass ? this.refPass.validity.valid : false;

    this.setState({
      validationStatusBeforeSubmit: {
        name: nameValid,
        email: emailValid,
        password: passwordValid
      }
    });
    if (nameValid && emailValid && passwordValid) {
      onSubmit(event, this.state);
    }
  };

  checkIsUserExist = async () => {
    let status = await progressStorage.userExists(this.state.email);
    if (status === USER_ALREADY_EXISTS) {
      this.setState({ isUserExist: true });
    } else {
      this.setState({ isUserExist: false });
    }
  };

  render() {
    const { onSubmit, formId, userEmail, userName } = this.props;
    return (
      <Form
        idElement={formId}
        onSubmit={event => {
          this.beforeSubmitValidation(event, onSubmit);
        }}
        noValidate
      >
        <InputContainer>
          <Input
            idInput="name"
            type={INPUT_TYPE.TEXT}
            refInput={node => {
              this.refName = node;
            }}
            name="name"
            labelText="Name"
            value={this.state.name}
            placeholder="John Doe"
            defaultValue={userName}
            onChange={this.onChange}
            validIcon={true}
            pattern="(:?[A-Za-zА-Яа-яЁё]+|\s*)+"
            validationStatusBeforeSubmit={this.state.validationStatusBeforeSubmit.name}
          />
        </InputContainer>
        <InputContainer>
          <Input
            idInput="email"
            refInput={node => {
              this.refEmail = node;
            }}
            type={INPUT_TYPE.EMAIL}
            name="email"
            labelText="Email"
            value={this.state.email}
            placeholder="john@example.com"
            defaultValue={userEmail}
            autoComplete="new-email"
            onChange={this.onChange}
            onBlur={this.checkIsUserExist}
            validIcon={true}
            textError={
              this.state.isUserExist ? localize('[user exist]') : localize('[error email input]')
            }
            validationStatusBeforeSubmit={this.state.validationStatusBeforeSubmit.email}
            isUserExist={this.state.isUserExist}
          />
        </InputContainer>
        <InputContainer>
          <Input
            idInput="password"
            type={INPUT_TYPE.PASSWORD}
            refInput={node => {
              this.refPass = node;
            }}
            name="password"
            placeholder="Password"
            labelText="Password"
            value={this.state.password}
            autoComplete="new-password"
            onChange={this.onChange}
            pattern="\S{7,}"
            validationStatusBeforeSubmit={this.state.validationStatusBeforeSubmit.password}
          />
        </InputContainer>
        <ButtonSubmit layout={BUTTON.LAYOUT.PRIMARY} suffixIcon="arrow-right" type="submit">
          {localize('[sign up button]')}
        </ButtonSubmit>
      </Form>
    );
  }
}

SignUp.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  formId: PropTypes.string,
  userEmail: PropTypes.string,
  userName: PropTypes.string
};

function mapStateToProps(state) {
  return {
    userEmail: getEmail(state),
    userName: getName(state)
  };
}

export default connect(mapStateToProps)(SignUp);
